import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from 'antd'
import { faUpload } from '@fortawesome/pro-solid-svg-icons/faUpload'
import { faAdd } from '@fortawesome/pro-solid-svg-icons/faAdd'
import { faList } from '@fortawesome/pro-solid-svg-icons/faList'
import { useTranslation } from 'react-i18next'
import { IQuestionBankSection } from 'interfaces/questionBank'
import { Wrapper } from './styled'

interface IProps {
  section: IQuestionBankSection
  addQuestion: () => void
  importQuestions: () => void
}

const Actions = ({ section, addQuestion, importQuestions }: IProps) => {
  const { t } = useTranslation()
  const translationPrefix = 'administration.blocks.type.questionBankV2.sections'

  return (
    <Wrapper>
      <span>
        <FontAwesomeIcon icon={faList} />
        {`${section.questions.length} ${t(
          `${translationPrefix}.${
            section.questions.length === 1 ? 'rowsCount' : 'rowsCountPlural'
          }`
        )}`}
      </span>
      <div>
        <Button onClick={importQuestions}>
          <FontAwesomeIcon icon={faUpload} />
          {t(`${translationPrefix}.actions.importQuestions`)}
        </Button>
        <Button onClick={addQuestion}>
          <FontAwesomeIcon icon={faAdd} />
          {t(`${translationPrefix}.actions.addQuestion`)}
        </Button>
      </div>
    </Wrapper>
  )
}

export default Actions
